import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { FocusTrap as H } from "@box/blueprint-web";
import { useRef as I, useCallback as R, useEffect as c } from "react";
import S from "react-dom";
import { usePropSyncedState as m } from "./hooks/usePropSyncedState.js";
import { s as b } from "../../chunks/hyperlink-popover.module.js";
import { BlurDetector as x } from "./subcomponents/blur-detector.js";
import { HyperlinkEditor as D } from "./subcomponents/hyperlink-editor.js";
import { HyperlinkPosition as F } from "./subcomponents/hyperlink-position.js";
import { jsx as r } from "react/jsx-runtime";
import "./subcomponents/edit-link.js";

var J = function J(_ref) {
  var p = _ref.defaultUrl,
      _ref$defaultIsOpen = _ref.defaultIsOpen,
      f = _ref$defaultIsOpen === void 0 ? !1 : _ref$defaultIsOpen,
      _ref$defaultIsEditing = _ref.defaultIsEditing,
      u = _ref$defaultIsEditing === void 0 ? !1 : _ref$defaultIsEditing,
      t = _ref.onOpenChange,
      a = _ref.onSubmit,
      n = _ref.onClear,
      o = _ref.onEditChange,
      d = _ref.anchor,
      y = _ref.zIndex,
      P = _ref.isReadonly,
      k = _ref.children;

  var i = I(null),
      _m = m(f),
      _m2 = _slicedToArray(_m, 2),
      e = _m2[0],
      v = _m2[1],
      _m3 = m(u),
      _m4 = _slicedToArray(_m3, 2),
      s = _m4[0],
      l = _m4[1],
      B = R(function () {
    v(!1), l(!1);
  }, []);

  return c(function () {
    t == null || t(e);
  }, [e]), c(function () {
    o == null || o(s);
  }, [s, o]), e && /* @__PURE__ */S.createPortal( /* @__PURE__ */r(x, {
    onBlur: B,
    children: /* @__PURE__ */r(H, {
      containerRef: i,
      customInitialFocus: function customInitialFocus() {
        return null;
      },
      children: /* @__PURE__ */r(F, {
        anchor: d,
        containerRef: i,
        zIndex: y,
        children: /* @__PURE__ */r("div", {
          className: b.popoverContent,
          children: /* @__PURE__ */r(D, {
            initialUrl: p,
            isEditing: s,
            isReadonly: P,
            onClear: n,
            onSubmit: a,
            setIsEditing: l,
            children: k
          })
        })
      })
    })
  }), document.querySelector("body"));
};

export { J as HyperlinkPopover };